(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["le-events-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('le-events-experience')) {
  customElements.define('le-events-experience', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.stories = Array.from(this.querySelectorAll('[data-story]'));
      this.limit = 6;
      this.search = this.querySelector('[data-event-search]');
      this.type = this.querySelector('[data-event-type]');
      this.year = this.querySelector('[data-event-year]');
      this.loadMore = this.querySelector('[data-load-more]');
      this.querySelectorAll('[data-calendar]').forEach(button => {
        if (this.validDate(button.dataset.start) && this.validDate(button.dataset.end)) {
          button.hidden = false;
          button.addEventListener('click', () => this.downloadCalendar(button), { signal });
        }
      });
      if (this.search) {
        this.querySelector('[data-filters]').hidden = false;
        this.querySelector('[data-results-row]').hidden = false;
        const filter = () => { this.limit = 6; this.applyFilters(); };
        this.search.addEventListener('input', filter, { signal });
        this.type.addEventListener('change', filter, { signal });
        this.year.addEventListener('change', filter, { signal });
        this.querySelectorAll('[data-reset]').forEach(button => button.addEventListener('click', () => {
          this.resetFilters();
          this.search.focus({ preventScroll: true });
        }, { signal }));
        this.loadMore.addEventListener('click', () => {
          const previousVisible = new Set(this.stories.filter(story => !story.hidden));
          this.limit += 6;
          this.applyFilters();
          const next = this.stories.find(story => !story.hidden && !previousVisible.has(story));
          next?.querySelector('summary')?.focus({ preventScroll: true });
        }, { signal });
        this.applyFilters();
      }
      this.stories.forEach(story => story.addEventListener('toggle', () => {
        if (!story.open) story.querySelectorAll('video').forEach(video => video.pause());
      }, { signal }));
      this.onHash = () => this.revealHash();
      window.addEventListener('hashchange', this.onHash, { signal });
      this.revealHash();
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;
        if (!id) return;
        const target = Array.from(this.querySelectorAll('[data-shopify-editor-block]')).find(node => {
          try { return JSON.parse(node.getAttribute('data-shopify-editor-block')).id === id; }
          catch { return false; }
        });
        if (!target) return;
        if (target.matches('[data-story]')) {
          this.showStory(target);
        } else {
          target.scrollIntoView({ block: 'center', behavior: 'instant' });
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
    normalize(value) {
      return String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    }
    resetFilters() {
      if (!this.search) return;
      this.search.value = '';
      this.type.value = 'all';
      this.year.value = 'all';
      this.limit = 6;
      this.applyFilters();
    }
    applyFilters() {
      const query = this.normalize(this.search.value);
      const tokens = query.split(/\s+/).filter(Boolean);
      const type = this.type.value, year = this.year.value;
      const matches = this.stories.filter(story => {
        const text = this.normalize(story.dataset.search);
        return tokens.every(token => text.includes(token)) && (type === 'all' || story.dataset.type === type) && (year === 'all' || story.dataset.year === year);
      });
      const shown = new Set(matches.slice(0, this.limit));
      this.stories.forEach(story => {
        story.hidden = !shown.has(story);
        if (story.hidden && story.open) story.open = false;
        if (story.hidden) story.querySelectorAll('video').forEach(video => video.pause());
      });
      this.loadMore.hidden = matches.length <= this.limit;
      this.querySelector('[data-no-results]').hidden = matches.length !== 0;
      this.querySelector('[data-results]').textContent = this.dataset.resultsTemplate.replace('[visible]', String(Math.min(this.limit, matches.length))).replace('[total]', String(matches.length));
      this.querySelector('[data-results-row] [data-reset]').hidden = !query && type === 'all' && year === 'all';
    }
    showStory(story) {
      if (this.search) {
        this.search.value = '';
        this.type.value = 'all';
        this.year.value = 'all';
        this.limit = Math.max(6, this.stories.indexOf(story) + 1);
        this.applyFilters();
      }
      story.hidden = false;
      story.open = true;
      requestAnimationFrame(() => story.scrollIntoView({ block: 'start', behavior: 'instant' }));
    }
    revealHash() {
      let hash;
      try { hash = decodeURIComponent(location.hash.slice(1)); } catch { return; }
      if (!hash.startsWith('event-')) return;
      const story = this.stories.find(item => item.id === hash);
      if (story) this.showStory(story);
    }
    validDate(value) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
      const date = new Date(value + 'T00:00:00Z');
      return !Number.isNaN(date.valueOf()) && date.toISOString().slice(0, 10) === value;
    }
    downloadCalendar(button) {
      const { start, end, title, location, description, url } = button.dataset;
      if (!this.validDate(start) || !this.validDate(end) || end < start) return;
      const afterEnd = new Date(end + 'T00:00:00Z');
      afterEnd.setUTCDate(afterEnd.getUTCDate() + 1);
      const compact = value => value.replace(/-/g, '');
      const escape = value => String(value || '').replace(/\\/g, '\\\\').replace(/\r?\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
      const stamp = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Liang and Eimil//Events//EN', 'CALSCALE:GREGORIAN', 'METHOD:PUBLISH', 'BEGIN:VEVENT', 'UID:' + compact(start) + '-' + button.closest('[data-event-feature]').id + '@liangandeimil.com', 'DTSTAMP:' + stamp, 'DTSTART;VALUE=DATE:' + compact(start), 'DTEND;VALUE=DATE:' + compact(afterEnd.toISOString().slice(0, 10)), 'SUMMARY:' + escape(title), 'LOCATION:' + escape(location), 'DESCRIPTION:' + escape(description), 'URL:' + escape(url), 'END:VEVENT', 'END:VCALENDAR'];
      const fold = line => {
        const parts = []; let current = '', size = 0;
        for (const char of line) {
          const bytes = new TextEncoder().encode(char).length;
          if (size + bytes > 73) { parts.push(current); current = ' '; size = 1; }
          current += char; size += bytes;
        }
        parts.push(current); return parts.join('\r\n');
      };
      const blob = new Blob([lines.map(fold).join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' });
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl; link.download = 'liang-eimil-' + compact(start) + '.ics';
      document.body.appendChild(link); link.click(); link.remove();
      setTimeout(() => URL.revokeObjectURL(blobUrl), 3000);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["le-material-tools"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.LEMaterials) return;
  const normalise = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/\bcrib\s*5\b/g,'').replace(/\bcap(?:p)?el(?:l)?a\b/g,'capella').replace(/&/g,' and ').replace(/[^a-z0-9]+/g,' ').replace(/\s+/g,' ').trim();
  const parse = node => { try { return JSON.parse(node?.textContent || '{}'); } catch { return {}; } };
  const element = (tag, className, text) => { const node=document.createElement(tag); if(className)node.className=className;if(text!==undefined)node.textContent=text;return node; };
  const jsonRecords = root => [...root.querySelectorAll('[data-material-entry]')].map(parse).filter(r=>r&&typeof r.id==='string'&&typeof r.title==='string').map(r=>({...r,products:Array.isArray(r.products)?r.products.filter(p=>typeof p==='string'):[]}));
  const safeImage = value => {try {const u=new URL(value,location.origin);return ['http:','https:'].includes(u.protocol)?u.href:'';}catch{return '';}};
  function richText(node, value) {
    const body=new DOMParser().parseFromString(String(value || ''),'text/html').body;
    body.querySelectorAll('script,style,iframe,object,embed,form,input,button').forEach(n=>n.remove());
    body.querySelectorAll('*').forEach(n=>[...n.attributes].forEach(a=>{if(a.name.startsWith('on')||a.name==='style'||(['href','src'].includes(a.name)&&!safeImage(a.value)))n.removeAttribute(a.name);}));
    node.replaceChildren(...[...body.childNodes].map(n=>document.importNode(n,true)));
  }
  const stores=new Map();
  function selection(customer) {
    if(stores.has(customer))return stores.get(customer);
    const key='le_material_selection_v2:'+customer;let values=[];
    try {const saved=JSON.parse(localStorage.getItem(key)||'[]');if(Array.isArray(saved))values=[...new Set(saved.filter(v=>typeof v==='string'&&v.length>0&&v.length<=150))].slice(0,200);}catch{}
    const listeners=new Set();
    const store={get values(){return [...values];},has:title=>values.includes(title),toggle(title){values=values.includes(title)?values.filter(v=>v!==title):[...values,title];this.commit();},add(title){if(!values.includes(title)){values.push(title);this.commit();}},remove(title){values=values.filter(v=>v!==title);this.commit();},clear(){values=[];this.commit();},commit(){try{localStorage.setItem(key,JSON.stringify(values));}catch{}listeners.forEach(fn=>fn([...values]));},subscribe(fn){listeners.add(fn);fn([...values]);return()=>listeners.delete(fn);}};
    stores.set(customer,store);return store;
  }
  function materialKeys(record) { return [...new Set([record.title,...String(record.aliases || '').split(/[,;\n]/)].map(normalise).filter(Boolean))]; }
  const selectionName=(record,records)=>records.filter(r=>normalise(r.title)===normalise(record.title)).length>1?record.title+' ('+record.group+')':record.title;
  function matchMaterials(records, finish, handle) {
    const key=normalise(finish);if(!key)return [];
    const parts=String(finish).split(/\s(?:and|with|&|\+|\/)\s|,\s*/i).map(normalise).filter(Boolean);
    const linked=records.filter(r=>r.products?.includes(handle));
    const candidates=records.map(record=>({record,keys:materialKeys(record).filter(k=>parts.includes(k)||(k.split(' ').length>1&&(' '+key+' ').includes(' '+k+' ')))})).filter(c=>c.keys.length);
    if(!candidates.length)return linked;
    const resolved=[];
    const groups=new Map();candidates.forEach(c=>{const k=normalise(c.record.title);if(!groups.has(k))groups.set(k,[]);groups.get(k).push(c);});
    for(const items of groups.values()) {
      let chosen=items;
      if(items.length>1){const direct=items.filter(c=>c.record.products?.includes(handle));chosen=direct.length===1?direct:[];}
      chosen.forEach(c=>{
        const longest=Math.max(...c.keys.map(k=>k.length));
        const overshadowed=candidates.some(other=>other.record.id!==c.record.id&&other.keys.some(k=>k.length>longest&&c.keys.some(own=>(' '+k+' ').includes(' '+own+' '))));
        if(!overshadowed)resolved.push(c.record);
      });
    }
    return resolved;
  }
  function reviewRequest(event) {
    if(event)event.preventDefault();const details=document.getElementById('request-samples');if(!details)return;
    details.open=true;details.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
  }
  const fetches=new Map();
  function loadLibrary(path) {
    const url=new URL(path,location.origin);if(url.origin!==location.origin)return Promise.reject(new Error('same-origin library required'));
    const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
    if(!fetches.has(url.href))fetches.set(url.href,fetch(url.href,{credentials:'same-origin',cache:'no-store'}).then(r=>{if(!r.ok)throw new Error('library unavailable');return r.text();}).then(html=>jsonRecords(new DOMParser().parseFromString(html,'text/html'))));
    return fetches.get(url.href);
  }
  window.LEMaterials={normalise,matchMaterials,jsonRecords,selection,loadLibrary};

  class MaterialDialog {
    constructor(owner, options={}) {
      this.owner=owner;this.node=owner.querySelector('.le-mat-dialog');this.options=options;this.current=null;
      if(!this.node)return;
      this.labels=parse(this.node.querySelector('[data-dialog-labels]'));this.abort=new AbortController();const signal=this.abort.signal;
      this.node.querySelector('[data-dialog-close]').addEventListener('click',()=>this.node.close(),{signal});
      this.node.addEventListener('click',event=>{if(event.target===this.node)this.node.close();},{signal});
      this.node.querySelector('[data-dialog-zoom]').addEventListener('click',event=>{const button=event.currentTarget;button.setAttribute('aria-pressed',String(button.getAttribute('aria-pressed')!=='true'));},{signal});
      this.node.querySelector('[data-dialog-add]').addEventListener('click',()=>{if(this.current)this.options.add?.(this.current);this.node.close();},{signal});
      this.node.querySelector('[data-dialog-related]')?.addEventListener('toggle',event=>{if(event.currentTarget.open)this.loadProducts();},{signal});
    }
    open(record) {
      if(!this.node)return;this.current=record;
      const set=(q,value)=>{this.node.querySelector(q).textContent=value||'';};
      set('[data-dialog-title]',record.title);set('[data-dialog-group]',record.group);set('[data-dialog-texture]',record.texture);set('[data-dialog-suitable]',record.suitable);set('[data-dialog-status]',record.status);set('[data-dialog-commercial]',record.commercial);
      this.node.querySelector('[data-dialog-commercial-row]').hidden=!record.commercial;
      this.node.querySelector('[data-dialog-texture-row]').hidden=!record.texture;this.node.querySelector('[data-dialog-suitable-row]').hidden=!record.suitable;
      const image=this.node.querySelector('[data-dialog-image]');image.src=safeImage(record.image);image.alt=record.title;image.hidden=!record.image;
      this.node.querySelector('[data-dialog-zoom]').setAttribute('aria-pressed','false');
      richText(this.node.querySelector('[data-dialog-description]'),record.description||record.short);
      this.node.querySelector('[data-dialog-care]').textContent=record.care||'';
      richText(this.node.querySelector('[data-dialog-designer]'),record.designer_note);
      this.node.querySelector('.le-mat-notes').open=false;
      const flags=this.node.querySelector('[data-dialog-flags]');flags.replaceChildren();
      ['crib5','recycled','outdoor','hospitality','residential','workplace','senior'].forEach(key=>{if(record[key])flags.append(element('span','',this.labels[key]));});
      const productMode=this.options.mode==='product';
      this.node.querySelector('[data-dialog-add]').hidden=productMode;
      const request=this.node.querySelector('[data-dialog-request]');request.hidden=!productMode;
      const library=this.node.querySelector('[data-dialog-library]');library.hidden=!productMode;
      if(productMode){const url=new URL(this.options.library,location.origin);url.searchParams.set('sample',record.title);url.searchParams.set('material_ids',record.id);url.hash='request-samples';request.href=url.href;url.searchParams.delete('sample');url.searchParams.delete('material_ids');url.searchParams.set('view_sample',record.title);url.searchParams.set('view_material',record.id);url.hash='';library.href=url.href;}
      const related=this.node.querySelector('[data-dialog-related]');if(related){related.open=false;related.hidden=!record.products?.length;this.node.querySelector('[data-dialog-product-count]').textContent=record.products?.length||'';this.node.querySelector('[data-dialog-products]').replaceChildren();this.loadedProductId=null;}
      if(!this.node.open)this.node.showModal();
    }
    destroy(){this.abort?.abort();if(this.node?.open)this.node.close();}
    async loadProducts() {
      const record=this.current;if(!record||this.loadedProductId===record.id)return;this.loadedProductId=record.id;
      const grid=this.node.querySelector('[data-dialog-products]');grid.replaceChildren(element('p','le-mat-note',this.labels.loading));
      const results=await Promise.allSettled(record.products.slice(0,4).map(async handle=>{
        const response=await fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});if(!response.ok)throw new Error('product unavailable');return response.json();
      }));
      if(this.current?.id!==record.id)return;grid.replaceChildren();
      results.forEach(result=>{if(result.status!=='fulfilled')return;const product=result.value;const link=element('a','le-mat-related-product');link.href='/products/'+encodeURIComponent(product.handle);if(product.featured_image){const img=element('img');img.src=safeImage(product.featured_image);img.alt=product.title;img.loading='lazy';img.width=240;img.height=192;link.append(img);}link.append(element('span','',product.title));grid.append(link);});
      if(!grid.children.length)grid.append(element('p','le-mat-note',this.labels.noProducts));
    }
  }

  if(!customElements.get('le-material-library'))customElements.define('le-material-library',class extends HTMLElement {
    connectedCallback(){
      if(this.started)return;this.started=true;this.abort=new AbortController();const signal=this.abort.signal;
      this.scope=this.closest('main')||document;this.labels=parse(this.querySelector('[data-material-labels]'));this.store=selection(this.dataset.customer);this.page=1;
      if(this.scope.style)this.scope.style.setProperty('--le-material-columns',this.dataset.columns||'4');
      this.search=this.querySelector('[data-material-search]');this.category=this.querySelector('[data-material-category]');
      this.dialog=new MaterialDialog(this,{add:record=>this.store.add(selectionName(record,this.records))});
      this.refresh();this.unsubscribe=this.store.subscribe(()=>this.renderSelected());
      this.search.addEventListener('input',()=>{this.page=1;this.render();},{signal});this.category.addEventListener('change',()=>{this.page=1;this.render();},{signal});
      this.querySelector('[data-material-reset]').addEventListener('click',()=>{this.search.value='';this.category.value='all';this.page=1;this.render();},{signal});
      this.scope.addEventListener('click',event=>{const open=event.target.closest('[data-material-open]'),add=event.target.closest('[data-material-add]'),review=event.target.closest('[data-review-selection]');if(open){const record=this.records.find(r=>r.id===open.dataset.materialOpen);if(record)this.dialog.open(record);}if(add){const record=this.records.find(r=>r.id===add.dataset.materialAdd);if(record)this.store.toggle(selectionName(record,this.records));}if(review)reviewRequest(event);},{signal});
      document.addEventListener('shopify:section:load',()=>this.refresh(),{signal});
      document.addEventListener('shopify:block:select',event=>{const card=event.target.closest('[data-material-card]');if(!card)return;this.search.value='';this.category.value='all';const index=this.records.findIndex(r=>r.id===card.dataset.materialId);this.page=Math.floor(index/this.pageSize)+1;this.render();card.scrollIntoView({block:'center'});},{signal});
      document.addEventListener('shopify:section:select',event=>{const group=event.target.querySelector('[data-material-group]');if(!group)return;this.search.value='';this.category.value=group.dataset.materialGroup;this.page=1;this.render();},{signal});
      const params=new URLSearchParams(location.search);const requested=params.get('sample');
      const ids=(params.get('material_ids')||'').split(',').filter(Boolean),identified=ids.map(id=>this.records.find(r=>r.id===id)).filter(Boolean);
      if(ids.length&&identified.length===ids.length)identified.forEach(record=>this.store.add(selectionName(record,this.records)));
      else if(requested)requested.split(',').map(v=>v.trim()).filter(Boolean).forEach(name=>{const matches=this.records.filter(r=>normalise(r.title)===normalise(name));this.store.add(matches.length===1?matches[0].title:name.slice(0,150));});
      const view=params.get('view_sample'),viewId=params.get('view_material');const identifiedView=this.records.find(r=>r.id===viewId);
      if(identifiedView)this.dialog.open(identifiedView);else if(view){const matches=this.records.filter(r=>normalise(r.title)===normalise(view));if(matches.length===1)this.dialog.open(matches[0]);}
      if(location.hash==='#request-samples')reviewRequest();
    }
    disconnectedCallback(){this.abort?.abort();this.unsubscribe?.();this.dialog?.destroy();this.started=false;}
    refresh(){
      this.records=jsonRecords(this.scope);this.cards=new Map([...this.scope.querySelectorAll('[data-material-card]')].map(card=>[card.dataset.materialId,card]));this.pageSize=Number(this.dataset.pageSize)||12;
      const current=this.category.value;this.category.replaceChildren(new Option(this.labels.all,'all'));
      [...new Set(this.records.map(r=>r.group).filter(Boolean))].forEach(group=>this.category.add(new Option(group,group)));
      this.category.value=[...this.category.options].some(o=>o.value===current)?current:'all';this.render();this.renderSelected();
    }
    filtered(){const query=normalise(this.search.value),category=this.category.value;return this.records.filter(r=>(category==='all'||r.group===category||(category==='Crib 5'&&r.crib5)||(category==='Recycled'&&r.recycled)||(category==='Outdoor'&&r.outdoor))&&(!query||normalise([r.title,r.aliases,r.group,r.category,r.short,r.texture].join(' ')).includes(query)));}
    render(){
      const filtered=this.filtered(),pages=Math.max(1,Math.ceil(filtered.length/this.pageSize));this.page=Math.max(1,Math.min(this.page,pages));
      const visible=new Set(filtered.slice((this.page-1)*this.pageSize,this.page*this.pageSize).map(r=>r.id));
      this.cards.forEach((card,id)=>{card.hidden=!visible.has(id);if(!card.hidden)card.querySelectorAll('img[data-material-src]').forEach(img=>{img.src=img.dataset.materialSrc;delete img.dataset.materialSrc;});});
      this.scope.querySelectorAll('[data-material-group]').forEach(group=>{group.hidden=![...group.querySelectorAll('[data-material-card]')].some(card=>!card.hidden);});
      this.querySelector('[data-material-results]').textContent=this.labels.results.replace('{count}',filtered.length).replace('{total}',this.records.length);
      this.querySelector('[data-material-empty]').hidden=filtered.length>0;this.querySelector('[data-material-reset]').hidden=!this.search.value&&this.category.value==='all';
      const nav=this.scope.querySelector('[data-material-pagination]');if(nav){nav.replaceChildren();nav.hidden=pages<=1;if(pages>1){const prev=element('button','le-mat-button le-mat-button--outline',this.labels.previous),next=element('button','le-mat-button le-mat-button--outline',this.labels.next);prev.type=next.type='button';prev.disabled=this.page===1;next.disabled=this.page===pages;const step=direction=>{this.page+=direction;this.render();this.scrollIntoView({block:'start'});};prev.addEventListener('click',()=>step(-1));next.addEventListener('click',()=>step(1));nav.append(prev,element('span','le-mat-note',this.labels.page+' '+this.page+' '+this.labels.of+' '+pages),next);}}
    }
    renderSelected(){
      if(!this.records)return;this.querySelectorAll('[data-material-count]').forEach(n=>{n.textContent=this.store.values.length;});
      this.records.forEach(record=>{const button=this.cards.get(record.id)?.querySelector('[data-material-add]');if(button){const selected=this.store.has(selectionName(record,this.records));button.textContent=selected?this.labels.added:this.labels.add;button.setAttribute('aria-pressed',String(selected));}});
    }
  });

  if(!customElements.get('le-material-request'))customElements.define('le-material-request',class extends HTMLElement {
    connectedCallback(){
      if(this.started)return;this.started=true;this.abort=new AbortController();const signal=this.abort.signal;
      this.labels=parse(this.querySelector('[data-request-labels]'));this.store=selection(this.dataset.customer);this.form=this.querySelector('form');this.extra=this.querySelector('[data-request-extra]');
      this.unsubscribe=this.store.subscribe(values=>this.update(values));this.extra.addEventListener('input',()=>this.updateFields(),{signal});
      this.querySelector('[data-review-selection]').addEventListener('click',reviewRequest,{signal});
      window.addEventListener('hashchange',()=>{if(location.hash==='#request-samples')reviewRequest();},{signal});
      if(location.hash==='#request-samples')reviewRequest();
      this.form.addEventListener('submit',async event=>{
        event.preventDefault();this.updateFields();if(!this.form.reportValidity())return;
        const status=this.querySelector('[data-request-status]'),button=this.form.querySelector('[type="submit"]');
        if(this.form.querySelector('[name="website"]').value.trim())return;
        if(!this.form.getAttribute('action')){status.textContent=this.labels.error;return;}
        button.disabled=true;button.textContent=this.labels.submitting;status.textContent='';
        try{const response=await fetch(this.form.action,{method:'POST',body:new FormData(this.form)});if(!response.ok)throw new Error('request failed');this.form.replaceChildren(element('p','le-mat-success',this.labels.sent));this.store.clear();}
        catch{button.disabled=false;button.textContent=this.labels.submit;status.textContent=this.labels.error;status.setAttribute('role','alert');}
      },{signal});
    }
    disconnectedCallback(){this.abort?.abort();this.unsubscribe?.();this.started=false;}
    update(values){
      this.querySelectorAll('[data-material-count]').forEach(node=>{node.textContent=values.length;});
      this.querySelector('[data-selection-bar]').hidden=values.length===0;
      const list=this.querySelector('[data-material-selected]');list.replaceChildren();
      values.forEach(title=>{const pill=element('span','le-mat-selected-item');pill.append(element('span','',title));const remove=element('button','','×');remove.type='button';remove.setAttribute('aria-label',this.labels.remove+' '+title);remove.addEventListener('click',()=>this.store.remove(title));pill.append(remove);list.append(pill);});
      this.querySelector('[data-material-selection-empty]').hidden=values.length>0;this.updateFields();
    }
    updateFields(){
      if(!this.form.querySelector('[name="Selected Samples"]'))return;
      const values=this.store.values,extra=this.extra.value.trim(),combined=[values.join(', '),extra].filter(Boolean).join('\n');
      this.form.querySelector('[name="Selected Samples"]').value=values.join(', ');this.form.querySelector('[name="Design Palette"]').value=values.join(' | ');this.form.querySelector('[name="Requested Fabrics"]').value=combined;
      this.extra.required=values.length===0;this.extra.setCustomValidity(combined.length>1000?this.labels.tooLong:'');
    }
  });

  if(!customElements.get('le-product-materials'))customElements.define('le-product-materials',class extends HTMLElement {
    connectedCallback(){
      if(this.started||!this.hasAttribute('data-material-access'))return;this.started=true;this.labels=parse(this.querySelector('[data-product-material-labels]'));this.dialog=new MaterialDialog(this,{mode:'product',library:this.dataset.libraryUrl});
      const load=()=>{this.observer?.disconnect();this.load();};
      if('IntersectionObserver' in window){this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))load();},{rootMargin:'250px'});this.observer.observe(this);}else load();
    }
    disconnectedCallback(){this.observer?.disconnect();this.dialog?.destroy();this.started=false;}
    async load(){
      const grid=this.querySelector('[data-product-materials]');
      try{
        const records=await loadLibrary(this.dataset.libraryUrl);if(!this.isConnected)return;
        const matches=matchMaterials(records,this.dataset.finish,this.dataset.productHandle);grid.replaceChildren();
        if(!matches.length){grid.append(element('p','le-mat-note',this.labels.unavailable));return;}
        matches.forEach(record=>{
          const button=element('button','le-mat-product-card');button.type='button';
          if(record.thumb){const image=element('img');image.src=safeImage(record.thumb);image.alt=record.title;image.width=180;image.height=144;image.loading='lazy';button.append(image);}else button.append(element('span','le-mat-product-placeholder',this.labels.imagePending));
          const text=element('span','');text.append(element('strong','',record.title),element('span','le-mat-note',record.group),element('span','le-mat-inspect',this.labels.view));button.append(text);button.addEventListener('click',()=>this.dialog.open(record));grid.append(button);
        });
        const url=new URL(this.dataset.libraryUrl,location.origin);url.searchParams.set('sample',[...new Set(matches.map(r=>r.title))].join(', '));url.searchParams.set('material_ids',matches.map(r=>r.id).join(','));url.hash='request-samples';this.querySelector('[data-product-request]').href=url.href;
      }catch{if(this.isConnected){grid.replaceChildren(element('p','le-mat-note',this.labels.unavailable));}}
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["le-sale-rsvp"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('le-sale-rsvp')){
  customElements.define('le-sale-rsvp',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const signal=this.controller.signal;
      this.form=this.querySelector('[data-rsvp-form]');
      const date=this.form.elements.date,time=this.form.elements.time,phone=this.form.elements.phone,email=this.form.elements.email,name=this.form.elements.name;
      const minute=value=>{const [h,m]=value.split(':').map(Number);return h*60+m;};
      const format=value=>{const h=Math.floor(value/60),m=value%60;return `${h%12||12}${m?':'+String(m).padStart(2,'0'):''}${h>=12?'pm':'am'}`;};
      const fillTimes=()=>{
        time.replaceChildren(new Option(this.dataset.timePlaceholder,''));
        const day=date.selectedOptions[0];
        time.disabled=!date.value;
        if(!date.value)return;
        const open=minute(day.dataset.open),close=minute(day.dataset.close);
        let available=0;
        for(let n=open;n<close;n+=30){
          const value=String(Math.floor(n/60)).padStart(2,'0')+':'+String(n%60).padStart(2,'0');
          if(new Date(`${date.value}T${value}:00+00:00`).getTime()<Date.now())continue;
          time.add(new Option(format(n),value));available++;
        }
        const error=this.querySelector('[data-rsvp-error]');error.hidden=true;
        if(!available){error.textContent=this.dataset.noTimes;error.hidden=false;time.disabled=true;}
      };
      for(const option of date.options){if(option.value&&new Date(`${option.value}T${option.dataset.close}:00+00:00`).getTime()<Date.now())option.disabled=true;}
      date.addEventListener('change',fillTimes,{signal});
      phone.addEventListener('input',()=>phone.setCustomValidity(''),{signal});
      email.addEventListener('input',()=>email.setCustomValidity(''),{signal});
      name.addEventListener('input',()=>name.setCustomValidity(''),{signal});
      this.form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(this.sending)return;
        const digits=phone.value.replace(/\D/g,'');
        phone.setCustomValidity(digits.length>=7&&digits.length<=15?'':this.dataset.phoneError);
        email.setCustomValidity(email.value.trim().toLowerCase()==='sales@liangandeimil.com'?this.dataset.emailError:'');
        name.setCustomValidity(name.value.trim()?'':this.dataset.nameError);
        if(!this.form.reportValidity())return;
        const values=Object.fromEntries(new FormData(this.form));
        const payload={event:'warehouse_sale_rsvp',name:values.name.trim(),email:values.email.trim().toLowerCase(),phone:values.phone.trim(),date:values.date,time:values.time,website:values.website||'',client_reference:this.reference||(this.reference='WS-'+crypto.randomUUID().slice(0,8).toUpperCase())};
        const error=this.querySelector('[data-rsvp-error]'),button=this.querySelector('[data-rsvp-submit]'),label=this.querySelector('[data-rsvp-button]');
        error.hidden=true;this.sending=true;button.disabled=true;const original=label.textContent;label.textContent=this.dataset.sending;
        const request=new AbortController();const timer=setTimeout(()=>request.abort(),20000);
        try{
          const endpoint=new URL(this.dataset.endpoint);
          if(endpoint.origin!=='https://hooks.zapier.com')throw Error('Invalid confirmation route');
          const response=await fetch(endpoint.href,{method:'POST',body:new URLSearchParams({payload:JSON.stringify(payload)}),signal:request.signal});
          if(!response.ok)throw Error('RSVP was not accepted');
          const receipt=this.querySelector('[data-rsvp-receipt]');
          this.querySelector('[data-rsvp-entry]').hidden=true;
          this.querySelector('[data-rsvp-preamble]').hidden=true;
          this.dataset.confirmed='true';
          this.dispatchEvent(new CustomEvent('le-sale-rsvp:confirmed',{bubbles:true}));
          this.querySelector('[data-rsvp-date]').textContent=new Intl.DateTimeFormat('en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'Europe/London'}).format(new Date(`${values.date}T12:00:00Z`));
          this.querySelector('[data-rsvp-time]').textContent=format(minute(values.time))+' · UK time';
          this.querySelector('[data-rsvp-email]').textContent=payload.email;
          receipt.hidden=false;receipt.focus();
        }catch(e){error.textContent=this.dataset.error;error.hidden=false;button.disabled=false;label.textContent=original;this.sending=false;}
        finally{clearTimeout(timer);}
      },{signal});
      fillTimes();
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["le-visit-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('le-visit-booking')) {
  customElements.define('le-visit-booking', class extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.form = this.querySelector('.le-vb-form');
      if(this.restoreWebhookReceipt())return;
      this.restoreReceipt();
      if (!this.form?.querySelector('[data-name]')) return;
      this.listeners = new AbortController();
      this.lunch = this.dataset.mode === 'lunch';
      this.pending = false;this.sent = false;
      this.errorBox = this.querySelector('[data-error-message]');
      this.success = this.querySelector('[data-success]');
      this.button = this.querySelector('[data-submit]');
      this.buttonLabel = this.querySelector('[data-submit-label]');
      this.defaultLabel = this.buttonLabel.textContent;
      const signal = this.listeners.signal;
      this.form.addEventListener('submit', event => this.submit(event), { signal });
      this.form.addEventListener('invalid', event => {
        const details = event.target.closest('details');if (details) details.open = true;
      }, { signal, capture: true });
      this.form.querySelector('[data-name]').addEventListener('input', event => event.target.setCustomValidity(''), { signal });
      this.form.querySelector('[data-virtual]')?.addEventListener('change', () => this.setVirtual(), { signal });
      this.setVirtual();
      if (this.lunch) {
        const date = this.form.querySelector('[data-preferred-date]');
        if (date) {
          date.min = this.londonParts().date;
          date.addEventListener('change', () => date.setCustomValidity(date.value && date.value < this.londonParts().date ? this.dataset.dateError : ''), { signal });
        }
      } else {
        this.prepareScheduler(signal);
      }
      this.querySelectorAll('.le-vb-film').forEach(details => details.addEventListener('toggle', () => {
        if (!details.open) details.querySelectorAll('video').forEach(video => video.pause());
      }, { signal }));
      document.addEventListener('shopify:block:select', event => {
        const id = event.detail?.blockId;if (!id) return;
        const selected = Array.from(this.querySelectorAll('[data-shopify-editor-block]')).find(node => {
          try { return JSON.parse(node.getAttribute('data-shopify-editor-block')).id === id; } catch { return false; }
        });
        if (selected?.tagName === 'DETAILS') selected.open = true;
      }, { signal });
    }
    disconnectedCallback() {
      this.listeners?.abort();this.requestController?.abort();this.listeners = null;
    }
    londonParts(timestamp = Date.now()) {
      const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(timestamp));
      const part = name => parts.find(value => value.type === name).value;
      return { date: part('year') + '-' + part('month') + '-' + part('day'), time: part('hour') + ':' + part('minute') };
    }
    addDay(value) {
      const date = new Date(value + 'T12:00:00Z');date.setUTCDate(date.getUTCDate() + 1);return date.toISOString().slice(0, 10);
    }
    workingDay(value) {
      const weekday = new Date(value + 'T12:00:00Z').getUTCDay();return weekday !== 0 && weekday !== 6;
    }
    requestLimit(timestamp = Date.now()) {
      return this.londonParts(Math.ceil((timestamp + this.noticeHours * 3600000) / 60000) * 60000);
    }
    minimumRequestDate(timestamp = Date.now()) {
      const limit = this.requestLimit(timestamp);
      let date = limit.time > this.closeTime ? this.addDay(limit.date) : limit.date;
      while (this.weekdaysOnly && !this.workingDay(date)) date = this.addDay(date);
      return date;
    }
    prepareScheduler(signal) {
      this.openTime = '09:00';this.closeTime = '16:30';this.weekdaysOnly = true;
      const hours = Number(this.dataset.noticeHours);
      this.noticeHours = Number.isFinite(hours) && hours >= 0 && hours <= 72 ? hours : 24;
      this.requestDate = this.form.querySelector('[data-request-date]');
      this.timeSlots = [...this.form.querySelectorAll('[data-time-slot]')];
      this.calendar = this.querySelector('[data-calendar-grid]');
      this.requestDate.min = this.minimumRequestDate();
      this.requestDate.value = this.requestDate.min;
      this.requestDate.required = false;
      this.querySelector('[data-date-fallback]').hidden = true;
      this.querySelector('[data-date-picker]').hidden = false;
      this.calendarMonth = this.requestDate.value.slice(0,7);
      this.querySelector('[data-month-prev]').addEventListener('click', () => this.changeMonth(-1), {signal});
      this.querySelector('[data-month-next]').addEventListener('click', () => this.changeMonth(1), {signal});
      this.calendar.addEventListener('click', event => {
        const button = event.target.closest('[data-day]');if (!button || button.disabled) return;
        this.requestDate.value = button.dataset.day;this.refreshSchedule();
      }, {signal});
      this.calendar.addEventListener('keydown', event => {
        const button = event.target.closest('[data-day]');if (!button) return;
        const moves = {ArrowLeft:-1,ArrowRight:1,ArrowUp:-7,ArrowDown:7};
        if (!(event.key in moves)) return;
        event.preventDefault();
        let day = button.dataset.day;
        const direction = Math.sign(moves[event.key]);
        for (let i=0;i<Math.abs(moves[event.key]);i++) day = this.shiftDay(day,direction);
        for (let i=0;i<7 && (!this.workingDay(day) || day < this.minimumRequestDate());i++) day=this.shiftDay(day,direction);
        if (day < this.minimumRequestDate()) return;
        this.calendarMonth=day.slice(0,7);this.paintCalendar();
        this.calendar.querySelector('[data-day="'+day+'"]')?.focus();
      }, {signal});
      this.requestDate.addEventListener('change', () => {this.calendarMonth=this.requestDate.value.slice(0,7);this.refreshSchedule();}, {signal});
      this.timeSlots.forEach(input => input.addEventListener('change', () => this.validateRequestedTime(), {signal}));
      this.refreshSchedule();
    }
    shiftDay(value,offset) {
      const date=new Date(value+'T12:00:00Z');date.setUTCDate(date.getUTCDate()+offset);return date.toISOString().slice(0,10);
    }
    timeValue() {return this.timeSlots.find(input=>input.checked)?.value || '';}
    allowedSlot(date,time) {
      const limit=this.requestLimit();
      return /^\d{4}-\d{2}-\d{2}$/.test(date) && this.workingDay(date) && date >= this.minimumRequestDate() && /^(09|10|11|13|14|15|16):(00|30)$/.test(time) && date+'T'+time >= limit.date+'T'+limit.time;
    }
    changeMonth(offset) {
      const date=new Date(this.calendarMonth+'-01T12:00:00Z');date.setUTCMonth(date.getUTCMonth()+offset);
      const next=date.toISOString().slice(0,7);if(next < this.minimumRequestDate().slice(0,7))return;
      this.calendarMonth=next;this.paintCalendar();
    }
    paintCalendar() {
      const [year,month]=this.calendarMonth.split('-').map(Number);
      const first=new Date(Date.UTC(year,month-1,1,12));
      const heading=new Intl.DateTimeFormat('en-GB',{month:'long',year:'numeric',timeZone:'UTC'}).format(first);
      this.querySelector('[data-calendar-month]').textContent=heading;
      this.querySelector('[data-month-prev]').disabled=this.calendarMonth <= this.minimumRequestDate().slice(0,7);
      const offset=(first.getUTCDay()+6)%7;
      const count=new Date(Date.UTC(year,month,0,12)).getUTCDate();
      const fragment=document.createDocumentFragment();
      for(let i=0;i<offset;i++){const blank=document.createElement('span');blank.setAttribute('aria-hidden','true');fragment.append(blank);}
      for(let number=1;number<=count;number++){
        const value=this.calendarMonth+'-'+String(number).padStart(2,'0');
        const button=document.createElement('button');button.type='button';button.dataset.day=value;button.textContent=number;
        button.disabled=!this.workingDay(value) || value < this.minimumRequestDate();
        const label=new Intl.DateTimeFormat('en-GB',{weekday:'long',day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(value+'T12:00:00Z'));
        button.setAttribute('aria-label',label);button.setAttribute('aria-pressed',String(value===this.requestDate.value));
        if(value===this.requestDate.value)button.setAttribute('aria-current','date');
        fragment.append(button);
      }
      this.calendar.replaceChildren(fragment);
      const selected=this.requestDate.value;
      this.querySelector('[data-selected-date]').textContent=selected?new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',timeZone:'UTC'}).format(new Date(selected+'T12:00:00Z')):'';
    }
    refreshSchedule() {
      this.paintCalendar();
      this.timeSlots.forEach(input=>{
        input.disabled=!this.allowedSlot(this.requestDate.value,input.value);
        if(input.disabled)input.checked=false;
      });
      this.querySelector('[data-no-times]').hidden=this.timeSlots.some(input=>!input.disabled);
      this.validateRequestedTime();
    }
    validateRequestedTime() {
      const day=this.requestDate.value,time=this.timeValue();
      this.requestDate.setCustomValidity('');this.timeSlots.forEach(input=>input.setCustomValidity(''));
      if(!day || !this.workingDay(day) || day < this.minimumRequestDate())return false;
      if(!time || !this.allowedSlot(day,time))return false;
      return true;
    }

    setVirtual() {
      if (this.lunch) return;
      const virtual = this.form.querySelector('[data-virtual]').checked;
      this.field('Appointment Type').value = virtual ? 'Virtual Appointment' : 'In-Person Showroom Visit';
      this.querySelector('[data-virtual-note]').hidden = !virtual;
      const method = this.field('Virtual Meeting Method');
      method.closest('.le-vb-field').hidden = !virtual;method.disabled = !virtual;
      if (!virtual) method.value = '';
    }
    makeReference() {
      if (!this.reference) this.reference='LE-'+(crypto.randomUUID?crypto.randomUUID():Date.now()+'-'+Math.random().toString(36).slice(2,10));return this.reference;
    }
    field(name) {
      const key=name==='Full Name'?'name':name==='Email'?'email':name;
      return this.form.elements.namedItem(this.lunch?name:'contact['+key+']');
    }
    restoreWebhookReceipt() {
      if(new URLSearchParams(location.search).get('booking_requested')!=='1'||!this.querySelector('[data-receipt-template]'))return false;
      try {
        const saved=JSON.parse(sessionStorage.getItem('le_visit_receipt')||'null');
        if(!saved?.accepted||!/^LE-[a-zA-Z0-9-]{5,80}$/.test(saved.reference||'')||!saved.createdAt||Date.now()-saved.createdAt>7200000||Date.now()<saved.createdAt)return false;
        if(String(saved.customer||'')!==String(this.dataset.customerKey||''))return false;
        return this.renderWebhookReceipt(false);
      } catch(error) {return false;}
    }
    renderWebhookReceipt(scroll=true) {
      const template=this.querySelector('[data-receipt-template]');if(!template||!this.form)return false;
      this.form.replaceWith(template.content.cloneNode(true));this.form=null;this.restoreReceipt();
      const receipt=this.querySelector('.le-vb-receipt');receipt?.focus({preventScroll:true});
      if(scroll)this.querySelector('.le-vb-panel')?.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      return true;
    }
    restoreReceipt() {
      const receipt=this.querySelector('.le-vb-receipt');
      if(!receipt)return;
      try{
        const raw=sessionStorage.getItem('le_visit_receipt');
        const saved=raw?.startsWith('{')?JSON.parse(raw):{reference:raw};
        if(!saved || !/^LE-[a-zA-Z0-9-]{5,80}$/.test(saved.reference||''))return;
        if(saved.createdAt && (Date.now()-saved.createdAt>7200000 || Date.now()<saved.createdAt))return;
        if(saved.customer && saved.customer!==this.dataset.customerKey)return;
        this.querySelector('[data-reference-value]').textContent=saved.reference;
        this.querySelector('[data-request-reference]').hidden=false;
        if(/^\d{4}-\d{2}-\d{2}$/.test(saved.date||'') && /^(09|10|11|13|14|15|16):(00|30)$/.test(saved.time||'') && ['Shoreditch','Enfield'].includes(saved.location)){
          this.querySelector('[data-receipt-location]').textContent=saved.location;
          this.querySelector('[data-receipt-date]').textContent=new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'}).format(new Date(saved.date+'T12:00:00Z'));
          this.querySelector('[data-receipt-time]').textContent=new Intl.DateTimeFormat('en-GB',{hour:'numeric',minute:'2-digit',hour12:true,timeZone:'UTC'}).format(new Date('2000-01-01T'+saved.time+':00Z'));
          this.querySelector('[data-receipt-summary]').hidden=false;
        }
        const account=this.querySelector('[data-receipt-account]');
        if(account){const url=new URL(account.href);url.searchParams.set('booking_reference',saved.reference);account.href=url.pathname+url.search+url.hash;}
      }catch{}
    }
    prepareShowroom() {
      const read=name=>String(this.field(name)?.value || '').trim();
      const reference=this.makeReference();
      const virtual=this.form.querySelector('[data-virtual]').checked;
      const type=virtual?'Virtual Appointment':'In-Person Showroom Visit';
      this.field('Request Reference').value=reference;
      this.field('Request Status').value='Pending team approval';
      this.field('Appointment Type').value=type;
      const notes=read('Project Details');
      const lines=['A showroom appointment has been requested. Please review the preferred date and time below and reply to the customer to confirm availability.'];
      if(notes)lines.push('Project notes: '+notes);
      this.form.elements.namedItem('contact[body]').value=lines.join('\n\n');
      for(const key of ['Company','Phone','Virtual Meeting Method','Virtual Meeting Method Other','Project Details']){const field=this.field(key);if(field && !String(field.value||'').trim())field.disabled=true;}
      try{sessionStorage.setItem('le_visit_receipt',JSON.stringify({version:1,reference,createdAt:Date.now(),customer:this.dataset.customerKey||'',location:read('Location'),date:read('Preferred Date'),time:this.timeValue()}));}catch{}

    }
    prepareLunch(data) {
      const read = name => String(data.get(name) || '').trim();
      const lines = ['Lunch & Learn request.', 'Company: ' + (read('Company Name') || 'Not provided'), 'Team size: ' + (read('Team Size') || 'To be agreed'), 'Preferred date: ' + (read('Preferred Date') || 'Flexible'), 'Notes: ' + (read('Visit Notes') || 'To be discussed')];
      data.set('Name', read('Name'));data.set('Email', read('Email'));data.set('Message', lines.join('\n'));
    }
    submit(event) {
      if(this.lunch)return this.submitLunch(event);
      if(this.pending || this.sent){event.preventDefault();return;}
      const name=this.form.querySelector('[data-name]');
      name.setCustomValidity(name.value.trim()?'':this.dataset.nameError);
      const honeypot=this.form.querySelector('[name="website"]');
      if(honeypot.value.trim()){event.preventDefault();return;}
      if(!this.validateRequestedTime()){
        event.preventDefault();this.errorBox.textContent=this.dataset.scheduleError;this.errorBox.hidden=false;
        if(!this.requestDate.value || !this.workingDay(this.requestDate.value) || this.requestDate.value<this.minimumRequestDate())this.calendar.focus();
        else this.timeSlots.find(input=>!input.disabled)?.focus();
        return;
      }
      if(!this.form.reportValidity()){event.preventDefault();return;}
      if(this.dataset.showroomAction){event.preventDefault();return this.submitShowroom();}
      this.prepareShowroom();this.errorBox.hidden=true;this.pending=true;this.button.disabled=true;this.buttonLabel.textContent=this.dataset.sending;
      window.addEventListener('pageshow',()=>{this.pending=false;this.button.disabled=false;this.buttonLabel.textContent=this.defaultLabel;},{once:true});
    }
    async submitShowroom() {
      this.prepareShowroom();
      const read=key=>String(this.field(key)?.value||'').trim();
      const payload={reference:this.reference,name:read('name'),email:read('email'),location:read('Location'),date:read('Preferred Date'),time:this.timeValue(),company:read('Company'),phone:read('Phone'),appointment_type:read('Appointment Type'),notes:[read('Project Details'),read('Virtual Meeting Method')?'Preferred virtual platform: '+read('Virtual Meeting Method'):'','Attendees: '+read('Attendees'),read('Client Attending')?'Client attending: '+read('Client Attending'):''].filter(Boolean).join('\n')};
      this.pending=true;this.errorBox.hidden=true;this.button.disabled=true;this.buttonLabel.textContent=this.dataset.sending;this.form.setAttribute('aria-busy','true');
      this.requestController=new AbortController();const timer=setTimeout(()=>this.requestController.abort(),20000);
      try {
        const endpoint=new URL(this.dataset.showroomAction);
        if(endpoint.origin!=='https://hooks.zapier.com')throw new Error('Booking route is unavailable');
        const response=await fetch(endpoint.href,{method:'POST',body:new URLSearchParams({payload:JSON.stringify(payload)}),signal:this.requestController.signal});
        if(!response.ok)throw new Error('Request was not accepted');
        this.sent=true;
        try{const saved=JSON.parse(sessionStorage.getItem('le_visit_receipt')||'{}');saved.accepted=true;sessionStorage.setItem('le_visit_receipt',JSON.stringify(saved));}catch{}
        const receipt=new URL(location.href);receipt.searchParams.delete('contact_posted');receipt.searchParams.set('booking_requested','1');receipt.hash='booking-form';history.replaceState(null,'',receipt.href);this.renderWebhookReceipt();
      } catch(error) {
        if(!this.isConnected)return;
        this.errorBox.textContent=this.dataset.error;this.errorBox.hidden=false;this.errorBox.focus({preventScroll:true});this.errorBox.scrollIntoView({block:'nearest',behavior:'instant'});
      } finally {
        clearTimeout(timer);this.pending=false;this.button.disabled=false;this.buttonLabel.textContent=this.defaultLabel;this.form?.removeAttribute('aria-busy');
      }
    }
    async submitLunch(event) {
      event.preventDefault();if (this.pending || this.sent) return;
      const name = this.form.querySelector('[data-name]');
      name.setCustomValidity(name.value.trim() ? '' : this.dataset.nameError);
      
      if (!this.form.reportValidity()) return;
      const data = new FormData(this.form);if (String(data.get('website') || '').trim()) return;
      this.pending = true;this.errorBox.hidden = true;this.button.disabled = true;this.buttonLabel.textContent = this.dataset.sending;
      this.form.setAttribute('aria-busy', 'true');this.requestController = new AbortController();
      const timer = setTimeout(() => this.requestController.abort(), 20000);
      try {
        this.prepareLunch(data);
        const response = await fetch(this.form.action, { method: 'POST', body: data, headers: { Accept: 'application/json' }, signal: this.requestController.signal });
        if (!response.ok) throw new Error('Request was not accepted');
        this.sent = true;this.form.hidden = true;this.success.hidden = false;
        if (!this.lunch) {
          this.querySelector('[data-reference-value]').textContent = this.reference;
          this.querySelector('[data-request-reference]').hidden = false;
        }
        this.success.focus({ preventScroll: true });
      } catch (error) {
        if (!this.isConnected) return;
        this.errorBox.textContent = this.dataset.error;this.errorBox.hidden = false;this.errorBox.focus({ preventScroll: true });
        this.errorBox.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      } finally {
        clearTimeout(timer);this.pending = false;this.button.disabled = false;this.buttonLabel.textContent = this.defaultLabel;this.form.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
